import ApiResourceManager from '../ApiResourceManager';

export default class OfferManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/offers',
      params,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/offers/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: 'offers',
      data,
    });

  delete = (data) =>
    this.request({
      method: 'DELETE',
      url: `offers/${data.id}`,
    });

  update = ({ id, ...data }) =>
    this.request({
      method: 'PATCH',
      url: `offers/${id}`,
      data,
    });

  uploadImage = (id, data) =>
    this.request({
      method: 'POST',
      url: `offers/${id}/images`,
      data,
    });

  deleteImage = (id, data) =>
    this.request({
      method: 'DELETE',
      url: `offers/${id}/images`,
      data,
    });

  generateImage = (id) =>
    this.request({
      method: 'POST',
      url: `offers/${id}/images/generate`,
    });
}
